import styles from "./footer_component.module.css";
import {useApp} from "../../context/AppDataContext";

export default function FooterComponent() {
    const {appVersion} = useApp();
    return (
        <div className={styles.footer} draggable={true}>
            <p>
                All Rights Reserved © {new Date().getFullYear()} v{appVersion}
            </p>
        </div>
    )
}